import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
/**
import CustomDatePicker from '../components/CommonDatePicker';
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/
import CommonButton from '../components/CommonButton';

class SearchUserDataUser extends Component {

    toggleUserTypes = (index) => {
        const { Searchs, onUpdateState } = this.props;
    
        const resetMap = {
            '0': ['academy_id', 'enterprise_id'],
            '1': ['academy_id', 'enterprise_id'],
            '2': ['enterprise_id'],
            '3': ['academy_id'],
        };
    
        const fieldsToReset = resetMap[index] || [];
    
        const updatedSearchs = {
            ...Searchs,
            ...Object.fromEntries(
                fieldsToReset.map(field => [field, { ...Searchs[field], value: '' }])
            )
        };
    
        onUpdateState('Searchs', updatedSearchs);
    };
    
    render = () => {
        let props = this.props;

        let AllowUsersTypes = ['0', '1' ]; // 0=Admin, 1=EEC staff, 2=acdemy

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation, UserCookie } = props;

        let { types, academy_id, enterprise_id, fullname, email, contact, username, status } = Searchs;

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row className="ms-2 me-2">
                    <Col md={12} className="custom-search-panel-body">                  
                        <Row className="mt-3">
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{types.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={types}
                                        option={{source: 'options', section: 'category', item: 'users'}}
                                        hr={false}
                                        callback={async (e, element) => {
                                            await onInputChange(e, element);
                                            this.toggleUserTypes(e.target.value);
                                        }}
                                        disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={6}>
                                {types.value === '2' && (
                                    <InputGroup className="mb-3">
                                        <InputGroup.Text className="input-group-text">{academy_id.label}</InputGroup.Text>
                                        <CommonSelect
                                            element="Searchs"
                                            input={academy_id}
                                            option={{source: 'db', data: Masterbase?.academy}}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)}
                                            disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                        />
                                    </InputGroup>
                                )}
                                {types.value === '3' && (
                                    <InputGroup className="mb-3">
                                        <InputGroup.Text className="input-group-text">{enterprise_id.label}</InputGroup.Text>
                                        <CommonSelect
                                            element="Searchs"
                                            input={enterprise_id}
                                            option={{source: 'db', data: Masterbase?.enterprise}}
                                            hr={false}
                                            callback={(e, element) => onInputChange(e, element)}
                                            disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                        />
                                    </InputGroup>                            
                                )}
                            </Col>                    
                        </Row>

                        <Row>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{fullname.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={fullname}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                        disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{username.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={username}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{email.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={email}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{contact.label}</InputGroup.Text>
                                    <CommonInput
                                        element="Searchs"
                                        input={contact}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <InputGroup className="mb-3">
                                    <InputGroup.Text className="input-group-text">{status.label}</InputGroup.Text>
                                    <CommonSelect
                                        element="Searchs"
                                        input={status}
                                        option={{source: 'options', section: 'status', item: 'users'}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </InputGroup>
                            </Col>
                            <Col md={3}>
                                <CommonButton 
                                    task="search" 
                                    disabled={Action.Loading.search ? true : false}
                                    callback={(e) => onSearch(e)} 
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </>
        )
    }
}

export default SearchUserDataUser;